import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Typography from '@mui/material/Typography';
import { computeIsGermanDefault, getCurrentLangCode } from '../utils/language';

const stepsDe = ["Datei Hochladen", "Preview & Bestätigung", "Produktauswahl", "Kundendaten & Zahlung", "Rechnung", "Ergebnisse"];
const stepsEn = ["Upload File", "Preview & Confirmation", "Product Choice", "Client Details & Payment", "Billing", "Results"];
const stepsPl = ["Prześlij plik", "Podgląd i potwierdzenie", "Wybór produktu", "Dane klienta i płatność", "Faktura", "Wyniki"];

function getUploadText(texts, key, fallback) {
  const v = texts && texts[key];
  if (v === undefined || v === null || v === '') return fallback;
  return String(v).trim();
}

function UploadProgress({ currentStep, isGerman: isGermanProp, uiTexts = {} }) {
  const [errorMessage, setErrorMessage] = useState('')
  const { activeStep, status } = currentStep; //  object destructuring
  const isGerman = typeof isGermanProp === 'boolean' ? isGermanProp : computeIsGermanDefault();
  const isPolish = getCurrentLangCode() === 'pl';
  const steps = isPolish
    ? [
      getUploadText(uiTexts, 'upload.steps.upload_file', stepsPl[0]),
      getUploadText(uiTexts, 'upload.steps.preview_confirmation', stepsPl[1]),
      getUploadText(uiTexts, 'upload.steps.product_choice', stepsPl[2]),
      getUploadText(uiTexts, 'upload.steps.client_details_payment', stepsPl[3]),
      getUploadText(uiTexts, 'upload.steps.billing', stepsPl[4]),
      getUploadText(uiTexts, 'upload.steps.results', stepsPl[5]),
    ]
    : (isGerman
    ? [
      getUploadText(uiTexts, 'upload.steps.upload_file', stepsDe[0]),
      getUploadText(uiTexts, 'upload.steps.preview_confirmation', stepsDe[1]),
      getUploadText(uiTexts, 'upload.steps.product_choice', stepsDe[2]),
      getUploadText(uiTexts, 'upload.steps.client_details_payment', stepsDe[3]),
      getUploadText(uiTexts, 'upload.steps.billing', stepsDe[4]),
      getUploadText(uiTexts, 'upload.steps.results', stepsDe[5]),
    ]
    : [
      getUploadText(uiTexts, 'upload.steps.upload_file', stepsEn[0]),
      getUploadText(uiTexts, 'upload.steps.preview_confirmation', stepsEn[1]),
      getUploadText(uiTexts, 'upload.steps.product_choice', stepsEn[2]),
      getUploadText(uiTexts, 'upload.steps.client_details_payment', stepsEn[3]),
      getUploadText(uiTexts, 'upload.steps.billing', stepsEn[4]),
      getUploadText(uiTexts, 'upload.steps.results', stepsEn[5]),
    ]);
  // console.log(`activestep = ${activeStep}, status=${status}`)

  const isStepFailed = (step) => {
    if (activeStep === step && status === 'invalid') {
      return true;
    }
    return false;
  }

  useEffect(() => {
    if (status === 'invalid') {
      setErrorMessage(getUploadText(uiTexts, 'upload.error.invalid_file', isPolish ? 'Proszę przesłać poprawny plik.' : (isGerman ? 'Bitte laden Sie eine gültige Datei hoch.' : 'Please upload a valid file.')));
    } else {
      setErrorMessage('');
    }
  }, [status, isGerman, isPolish, uiTexts]); // Run this effect whenever 'status' changes

  return (
    <Box sx={{ width: '100%' }} style={{
      width: '100%',
      height: 'auto',
      paddingBottom: '7%',
      margin: '0 auto'
    }}>
      <Stepper activeStep={activeStep}>
        {steps.map((label, index) => {
          const labelProps = {};

          if (isStepFailed(index)) {
            labelProps.optional = (
              <Typography variant="caption" color="error">
                {errorMessage}
              </Typography>
            );
            labelProps.error = true;
          }
          return (
            <Step key={label}>
              <StepLabel {...labelProps}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </Box>
  );
}

export default UploadProgress;